/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import AqaCellNote from './AqaCellNote';

/**
 * The AqaCellReviewRequest model module.
 * @module model/AqaCellReviewRequest
 * @version v0
 */
export default class AqaCellReviewRequest {
  /**
   * Constructs a new <code>AqaCellReviewRequest</code>.
   * @alias module:model/AqaCellReviewRequest
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaCellReviewRequest</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaCellReviewRequest} obj Optional instance to populate.
   * @return {module:model/AqaCellReviewRequest} The populated <code>AqaCellReviewRequest</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaCellReviewRequest();
      if (data.hasOwnProperty('review'))
        obj.review = ApiClient.convertToType(data['review'], 'Blob');
      if (data.hasOwnProperty('note'))
        obj.note = AqaCellNote.constructFromObject(data['note']);
    }
    return obj;
  }
}

/**
 * @member {Blob} review
 */
AqaCellReviewRequest.prototype.review = undefined;

/**
 * @member {module:model/AqaCellNote} note
 */
AqaCellReviewRequest.prototype.note = undefined;

